import React, { Component } from 'react';
import MDReactComponent from 'markdown-react-js';
import { withPrefix } from 'gatsby-link'

const isClient = typeof window !== 'undefined'

function linkRenderer(Tag, props, children, level) {
    if (Tag === 'a') {
      props = {
        ...props,
        target: '_blank'
      };
    }
    return <Tag {...props}>{children}</Tag>;
}

function getCookie(name) {
  if (isClient){
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  } else return null;
}


class CookiesControl extends Component {
    constructor(props) {
      super(props);
      this.lang = props.lang;
      this.state = {
          viewCookies: false,
          cookiesAccepted: isClient?getCookie('cookies-accepted')==="true":false
      }
      this.translations=props.translations;

      this.closeCookiesLayer = props.closeLayer;
      this.closeCookiesBox = props.closeCookiesBox;

      this.handleChange = this.handleChange.bind(this);
      this.closeLayer = this.closeLayer.bind(this);
      this.handleBtnAccept = this.handleBtnAccept.bind(this);
      this.cookiesAccepted= isClient?getCookie('cookies-accepted')==="true":false;
    }

    handleChange(event) {
    
      let checkValue = event.target.checked;
      console.log("accepted:"+this.cookiesAccepted+"-"+checkValue);
      this.state.cookiesAccepted=checkValue;
      
      if (checkValue) {
        if (isClient){
          var d = new Date();
          d.setTime(d.getTime() + (365 * 2 * 24 * 60 * 60 * 1000));
          var expires = "expires="+d.toUTCString();
          document.cookie = "gatsby-plugin-google-analytics-gdpr_cookies-enabled=true" + ";" + expires + ";path=/";
          document.cookie ="cookies-accepted=true"+ ";" + expires + ";path=/";
        }
      } else {
        if (isClient){
          var d = new Date();
          d.setTime(d.getTime() + (180 * 24 * 60 * 60 * 1000));
          var expires = "expires="+d.toUTCString();
          console.log("setting accept cookies to false");
          document.cookie = "gatsby-plugin-google-analytics-gdpr_cookies-enabled=false"+";" + expires + ";path=/";
          document.cookie = "cookies-accepted=false"+ ";" + expires + ";path=/";
          console.log("Removing ga cookies");
          document.cookie = "_ga=NOTHING; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=."+window.location.hostname;
          document.cookie = "_gat=NOTHING; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=."+window.location.hostname;
          document.cookie = "_gid=NOTHING; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=."+window.location.hostname;
        }
      }
      this.setState(this.state);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.openLayer !== this.state.viewCookies) {
          this.setState({viewCookies: nextProps.openLayer})
        }
    }

    closeLayer () {
      this.setState({viewCookies: false});
      if (this.state.cookiesAccepted==false){
        if (isClient){
          //if there is no cookie to false,put it to false
          if (getCookie("cookies-accepted")==null){
            var d = new Date();
            d.setTime(d.getTime() + (180 * 24 * 60 * 60 * 1000));
            var expires = "expires="+d.toUTCString();
            console.log("setting accept cookies to false");
            document.cookie = "gatsby-plugin-google-analytics-gdpr_cookies-enabled=false"+";" + expires + ";path=/";
            document.cookie = "cookies-accepted=false"+ ";" + expires + ";path=/";
            console.log("Removing ga cookies");
            document.cookie = "_ga=NOTHING; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=."+window.location.hostname;
            document.cookie = "_gat=NOTHING; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=."+window.location.hostname;
            document.cookie = "_gid=NOTHING; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=."+window.location.hostname;
          }
        }
      }
      this.closeCookiesLayer();
    }

    handleBtnAccept() {
      this.setState({viewCookies: false})
      this.closeCookiesBox();
    }

    render() {

      const printParagraf = (item, idx) => {
        return (
          <div key={idx}>
            <h4>{item.title}</h4>
            <MDReactComponent text={item.text} onIterate={linkRenderer} />
          </div>
        )
      }

      let showLayerClass = (this.state.viewCookies == true) ? 'cookiesControl showLayer' : 'cookiesControl'

      return (

        <div className={showLayerClass}>
          <div className="cookiesControl-wrapper">

              <div 
                className="closeBox"
                onClick={this.closeLayer}>
              </div>

              <h2>{this.translations.cookiecp_title}</h2>

              <div className="cookiesControl-content">

                  <MDReactComponent text={this.translations.cookiecp_text} onIterate={linkRenderer} />

                  {this.translations.cookiecp_firsts_paragraphs.map(printParagraf)}

                  <h3 id="cookieControlLink">{this.translations.cookiecp_own_title}</h3>
                  <MDReactComponent text={this.translations.cookiecp_own_text} onIterate={linkRenderer} />
                  
                  <div className="cookiesControl-ckcntrl">
                    
                    <label className="toggle-switch">
                        <input id="checkbox-disabled" type="checkbox" checked disabled  />
                        <span className="toggle-switch-slider toggle-switch-slider__disabled"> </span>
                    </label>

                    <p className='titleCookie'>{this.translations.cookiecp_tech_title}</p>
                    <MDReactComponent text={this.translations.cookiecp_tech_text} onIterate={linkRenderer} className="desc"/>
                  </div>

                  <h3>{this.translations.cookiecp_third_title}</h3>
                  <MDReactComponent text={this.translations.cookiecp_third_text} onIterate={linkRenderer} />

                  <div className="cookiesControl-ckcntrl">

                    <label className="toggle-switch">
                        <input id="checkbox" type="checkbox" checked={this.state.cookiesAccepted} onChange={this.handleChange}/>
                        <span className="toggle-switch-slider"> </span>
                    </label>

                    {/*<input type="checkbox" checked={this.state.cookiesAccepted} className="checkbox" onChange={this.handleChange}/>*/}
                    <p className='titleCookie'>{this.translations.cookiecp_analytics_title}</p>
                    <MDReactComponent text={this.translations.cookiecp_analytics_text} onIterate={linkRenderer} className="desc-sec"/>
                    <p className="desc-text">{this.translations.cookiecp_analytics_name}</p>
                  </div>
                  
                  
                  {this.translations.cookiecp_last_paragraphs.map(printParagraf)}
                  
                  
              </div>

          </div>
        </div>

      )
  }
};

export default CookiesControl;


// WEBPACK FOOTER //
// ./src/components/cookiesControl/index.js